module.exports = __webpack_public_path__ + "img/mahindra_logo.20af9823.svg";